import React from 'react';
import PropTypes from 'prop-types';

import { SEARCH_MIN_CHARS } from 'data/config/searchConfig';
import { DATA_TYPE_MEETING_CONTACTS } from 'data/config/dataConfig';
import { USER_DATA_PAGE_KEY } from 'src/pages/pagesKeys';
// import STATUS from 'src/store/fetchStatuses';

import DetailDataList from 'src/components/detail-data-list/DetailDataList';
import SearchField from 'src/components/search/SearchField';
import DummyKeyboardPlaceholder from 'src/components/dummy-keyboard-placeholder/DummyKeyboardPlaceholder';

import './MeetingContacts.scss';

class MeetingContacts extends React.Component {
  constructor(props) {
    super(props);

    this.performSearch = this.performSearch.bind(this);
    this.clearSearchResults = this.clearSearchResults.bind(this);
  }

  performSearch(value) {
    this.props.actions.searchOnASingleDataType(
      value,
      USER_DATA_PAGE_KEY,
      DATA_TYPE_MEETING_CONTACTS,
      this.props.meetingContacts
    );
  }

  clearSearchResults() {
    this.props.actions.clearSearchResults(USER_DATA_PAGE_KEY);
  }

  render() {
    let meetingContacts;
    if (this.props.searchResults) {
      meetingContacts = this.props.searchResults[DATA_TYPE_MEETING_CONTACTS];
    } else {
      meetingContacts = this.props.meetingContacts;
    }

    return (
      <div className="ud-meetingContacts">
        {/* <SearchField
          labels={this.props.labels}
          placeholder={this.props.labels.userData.meetingContactsSearchPlaceholder}
          clearResults={this.clearSearchResults}
          perform={this.performSearch}
          minChars={SEARCH_MIN_CHARS}
          hasClearButton
          hasCancelButton={false}
        /> */}

        <DetailDataList
          dataType={DATA_TYPE_MEETING_CONTACTS}
          items={Array.isArray(meetingContacts) ? meetingContacts : []}
          // isPending={Array.isArray(meetingContacts) ? false : meetingContacts.status === STATUS.PENDING}
          actions={this.props.actions}
          labels={this.props.labels}
          pageKey={USER_DATA_PAGE_KEY}
        />

        <DummyKeyboardPlaceholder keyboardHeight={this.props.keyboardHeight} />
      </div>
    );
  }
}

MeetingContacts.propTypes = {
  meetingContacts: PropTypes.array.isRequired,
  searchResults: PropTypes.object,
  searchedString: PropTypes.string,
  keyboardHeight: PropTypes.number,
  labels: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default MeetingContacts;
